import { createRootRouteWithContext, Outlet, redirect } from '@tanstack/react-router';
import type { AuthState } from '@/auth/AuthProvider';

/** Routes that need no session: the sign-in pages and a report opened by its secret link. */
const PUBLIC = ['/login', '/reset-password', '/r/'];

export const Route = createRootRouteWithContext<{ auth: AuthState }>()({
  beforeLoad: ({ context, location }) => {
    if (context.auth.status === 'anonymous' && !PUBLIC.some((p) => location.pathname.startsWith(p))) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: () => <Outlet />,
});
